import {
    Box, List, Divider, ListItem, ListItemButton,
    ListItemIcon, ListItemText, Icon
} from '@/components'
import { useNavigate } from 'react-router-dom'
import menu, { Menu } from '@/constants/menu'
import { useSession } from '@/hooks'
import { USER_TYPE_GUEST, USER_TYPE_INVITER } from '@/constants/prop/UserType'
import useStore from '@/store'
import { useCallback, useEffect, useState } from 'react'

function SideMenu ( props ) {
    const { setOpen } = props
    const navigator = useNavigate()
    const session = useSession()
    const { isLogin } = useStore()
    const [ displayMenu, setDisplayMenu ] = useState<Menu[]>( [] )
    const userType = session( 'userType' ) as string || USER_TYPE_GUEST.value
    const isInviter = userType === USER_TYPE_INVITER.value

    useEffect( () => {
        setDisplayMenu( menu.filter( m => m.isDisplay && m.authUserTypes.includes( userType ) ) )
    }, [ isLogin, userType ] )

    const getMenuListItem = (): JSX.Element | JSX.Element[] => displayMenu
        .map( ( { path = '', menuId, menuName, menuIcon, param }, idx ) => (
            <div key={ menuId }>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={ () => navigator( `/${ path }`, { state: { ...param } } ) }
                    >
                        <ListItemIcon>
                            <Icon color="primary">{ menuIcon }</Icon>
                        </ListItemIcon>
                        <ListItemText primary={ <span style={ { fontWeight: 500 } }>{ menuName }</span> }/>
                    </ListItemButton>
                </ListItem>
                { idx !== displayMenu.length - 1 && ( <Divider/>) }
            </div>
        ) )

    return (
        <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={ useCallback( () => {
                setOpen( false )
            }, [] ) }
        >
            <List>
                { getMenuListItem() }
            </List>
            <Divider />
        </Box>
    )
}

export default SideMenu